import { Routes } from '@angular/router';
import { AuthGuard } from '@core/services/auth-guard.service';
import { DevEnvGuard } from "@core/services/dev-env-guard.service";
import { NotInDemoGuard } from '@core/services/not-in-demo.guard';
import { NotInSalesDemoGuard } from '@core/services/not-in-sales-demo.guard';
import { ExternalSiteLoadComponent } from '@shared/components/external-site-load/external-site-load.component';
import { GenerateTokenComponent } from "./development-only/generate-token/generate-token.component";
import { MyDevicesComponent } from '@shared/components/my-devices/my-devices.component';
import {Configuration} from '@shared/models/configuration';
import {MEET_SHELL_TOP_BAR} from '@features/orbitax-meet/meet-shell-top-bar';
import {PlatformDonutChartComponent} from '@features/data-tracing/components/platform-donut-chart/platform-donut-chart.component';
import { PlatformLinkCreatorComponent } from '@shared/components/platform-tool/platform-link-creator/platform-link-creator.component';
import { DashboardModule } from './features/dashboard/dashboard.module';
import { AdminPanelModule } from '@features/admin-panel/admin-panel.module';
import { SupportModule } from '@features/support/support.module';

export const appRoutes: Routes = [
  {
    path: '',
    loadChildren: homeModuleResolver
  },
  {
    path: 'ed/entity-designer',
    loadChildren:
      () => import('./features/ed-entity-designer/ed-entity-designer.module').then(m => m.EdEntityDesignerModule),
  },
  {
    path: 'ed/dashboard',
    canActivate: [AuthGuard],
    loadChildren:
      () => import('./features/ed-entity-designer/ed-entity-designer.module').then(m => m.EdEntityDesignerModule),
  },
  {
    path: 'platform-donut-chart',
    component: PlatformDonutChartComponent
  },
  {
    path: 'projects/entity-data',
    loadChildren:
      () => import('./features/entity-chart/ed-entity-data/orbitax-ed-entity-data.module').then(m => m.OrbitaxEdEntityDataModule),
  },
  {
    path: 'projects/tax-rules',
    loadChildren: () => import('@features/eat/orbitax-workflow.module').then(m => m.OrbitaxWorkflowModule)
  },
  /*{
    path: 'preset-countries',
    loadChildren:
      () => import('./features/entity-chart/ed-entity-data/orbitax-ed-entity-data.module').then(m => m.OrbitaxEdEntityDataModule),
  },*/
  // {
  //   path     : 'projects/entity-data/filters/:magicLinkId',
  //   component: PlatformToolContainerComponent
  // },
  // {
  //   path     : 'projects/entity-data/eat/:magicLinkId',
  //   component: PlatformToolContainerComponent
  // },
  {
    path: 'projects/transaction-data/entity',
    loadChildren:
      () => import('./features/entity-chart/ed-entity-transactions/orbitax-entity-transactions.module').then(m => m.OrbitaxEntityTransactionsModule),
  },
  {
    path: 'projects/import-cbc-related-party-transactions',
    loadChildren:
      () => import('./features/entity-chart/ed-entity-transactions/orbitax-entity-transactions.module').then(m => m.OrbitaxEntityTransactionsModule),
  },
  {
    path: 'cbc/scenarios/import-entity-data',
    loadChildren:
      () => import('./features/entity-chart/ed-entity-data/orbitax-ed-entity-data.module').then(m => m.OrbitaxEdEntityDataModule),
  },
  // {
  //   path     : 'projects/transaction-data/eat/:magicLinkId',
  //   component: PlatformToolContainerComponent
  // },
  {
    path: 'projects/transaction-data/dividend',
    loadChildren:
      () => import('./features/entity-chart/ed-entity-transactions/orbitax-entity-transactions.module').then(m => m.OrbitaxEntityTransactionsModule),
  },
  {
    path: 'projects/transaction-data/country',
    loadChildren:
      () => import('./features/entity-chart/ed-entity-transactions/orbitax-entity-transactions.module').then(m => m.OrbitaxEntityTransactionsModule),
  },
  {
     path: 'ddt/filing-manager',
     loadChildren:
       () => import('./features/due-date-tracker/ddt-filing-manager.module').then(m => m.DdtFilingManagerModule),
  },
  {
    path: 'ddt/dashboard',
    canActivate: [AuthGuard],
    loadChildren:
      () => import('./features/due-date-tracker/ddt-filing-manager.module').then(m => m.DdtFilingManagerModule),
  },
  // {
  //   path: 'visualizer',
  //   loadChildren:
  //     '../../projects/lazy-load-wrapper-modules/visualizer-wrapper.module#OrbitaxVisualizerWrapperModule',
  // },
  {
    path: 'cr',
    loadChildren:
      () => import('./features/change-report/change-report.module').then(m => m.ChangeReportModule),
  },
  {
    path: 'et/entity-data',
    loadChildren:
      () => import('./features/entity-tracker/entity-data/entity-data.module').then(m => m.EntityDataModule),
  },
  {
    path: 'et/entity-reports',
    loadChildren:
      () => import('./features/entity-tracker/entity-report/entity-report.module').then(m => m.EntityReportModule),
  },
  {
    path: 'et/entity-change-reports',
    loadChildren:
      () => import('./features/entity-tracker/entity-change-report/entity-change-report.module').then(m => m.EntityChangeReportModule),
  },
  // {
  //   path: 'et/structural-transactions',
  //   loadChildren:
  //     '../../projects/lazy-load-wrapper-modules/mna-transaction-wrapper.module#MnATransactionWrapperModule',
  // },
  {
    path: 'et/structural-transactions',
    loadChildren:
      () => import('./features/entity-tracker/mna-transaction/mna-transaction.module').then(m => m.MnATransactionModule),
  },
  {
    path: 'et/data-mapping',
    loadChildren:
      () => import('./features/entity-tracker/data-mapping/data-mapping.module').then(m => m.DataMappingModule),
  },
  {
    path: 'et/dashboard',
    canActivate: [AuthGuard],
    loadChildren:
      () => import('./features/entity-tracker/entity-data/entity-data.module').then(m => m.EntityDataModule),
  },
  {
    path: 'taxnews',
    loadChildren:
      () => import('@features/taxnews/taxnews.module').then(m => m.TaxnewsModule)
  },
   {
     path: 'wht/procedures',
     loadChildren:
       () => import('@features/wht-procedures/orbitax-wht-procedures.module').then(m => m.OrbitaxWhtProceduresModule)

   },
  // {
  //   path: 'wht/library/:countryCode/:categoryId',
  //   loadChildren:
  //     () => import('@features/wht-library/orbitax-wht-commentary.module').then(m => m.OrbitaxWhtCommentaryModule),
  // },
  // {
  //   path: 'wht/library/:countryCode',
  //   loadChildren:
  //     () => import('@features/wht-library/orbitax-wht-commentary.module').then(m => m.OrbitaxWhtCommentaryModule),
  // },
  {
    path: 'wht/library',
    loadChildren:
      () => import('@features/wht-library/orbitax-wht-commentary.module').then(m => m.OrbitaxWhtCommentaryModule),
  },
  {
    path: 'wht/forms',
    loadChildren: () => import('@features/wht-forms/wht-forms.module').then(m => m.WhtFormsModule)
  },
  {
     path: 'wht/rates',
     loadChildren: () => import('@features/wht-rates/orbitax-wht-rates.module').then(m => m.OrbitaxWhtRatesModule)
   },
  {
    path: 'wht/dashboard',
    canActivate: [AuthGuard],
    loadChildren:
      () => import('@features/wht-library/orbitax-wht-commentary.module').then(m => m.OrbitaxWhtCommentaryModule),
  },
  {
    path: 'itrce',
    loadChildren: () => import('@features/itrce-planner/itrce-planner.module').then(m => m.ItrcePlannerModule)
  },
  // {
  //   path: 'itrce/expatriate/:countryCode/:categoryId',
  //   loadChildren:
  //     () => import('@features/expatriate-taxation/expatriate-taxation.module').then(m => m.ExpatriateTaxationModule),
  // },
  // {
  //   path: 'itrce/expatriate/:countryCode',
  //   loadChildren:
  //     () => import('@features/expatriate-taxation/expatriate-taxation.module').then(m => m.ExpatriateTaxationModule),
  // },
  {
    path: 'itrce/expatriate',
    loadChildren:
      () => import('@features/expatriate-taxation/expatriate-taxation.module').then(m => m.ExpatriateTaxationModule),
  },
  {
    path: 'itrce/analysis',
    loadChildren:
      () => import('@features/country-chapter/country-chapter.module').then(m => m.CountryChapterModule),
  },
  {
    path: 'ddt/library',
    loadChildren: () => import('@features/ddt-library/ddt-library.module').then(m => m.DdtLibraryModule),
  },
   {
     path: 'rates',
     loadChildren: () => import('@features/itrce-rates/orbitax-itrce-rates.module').then(m => m.OrbitaxItrceRatesModule)
   },
   {
     path: 'vat',
     loadChildren: () => import('@features/itrce-rates/orbitax-itrce-rates.module').then(m => m.OrbitaxItrceRatesModule)
   },
  {
    path: 'eat',
    loadChildren: () => import('@features/eat/orbitax-workflow.module').then(m => m.OrbitaxWorkflowModule)
  },
  {
    path: 'data-collection',
    loadChildren: () => import('@features/eat/orbitax-workflow.module').then(m => m.OrbitaxWorkflowModule)
  },
  {
    path: 'orbitax-microsoft-services',
    loadChildren: () => import('@features/orbitax-microsoft-services/orbitax-microsoft-services.module').then(m => m.OrbitaxMicrosoftServicesModule)
  },
  {
    path: 'admin-panel',
    loadChildren: homeModuleResolver
  },
  {
    path: 'search',
    loadChildren: () => import('@features/platform-search/platform-search.module').then(mod => mod.PlatformSearchModule)
  },
  {
    path: 'form/dac6-form-automation',
    loadChildren: () => import('@features/dac6-form-automation/dac6-form-automation.module').then(mod => mod.Dac6FormAutomationModule)
  },
  {
    path: 'drive/power-bi-schema-designer',
    loadChildren: () => import('@features/power-bi-schema-designer/power-bi-schema-designer.module').then(mod => mod.PowerBiSchemaDesignerModule)
  },
  {
    path: 'drive/eat-workflow',
    loadChildren: () => import('@features/eat/orbitax-workflow.module').then(m => m.OrbitaxWorkflowModule)
  },
  {
    path     : 'user-journey',
    component: ExternalSiteLoadComponent
  },
  {
    path: 'transaction-tracker/eat-workflow',
    loadChildren: () => import('@features/eat/orbitax-workflow.module').then(m => m.OrbitaxWorkflowModule)
  },
  {
    path: 'itp-desktop',
    loadChildren:
      () => import('./features/itp-desktop/itp-desktop.module').then(m => m.ItpDesktopModule),
  },
  {
    // ITP-P-54 D2: the Marketplace is closed inside a demo.
    path: 'marketplace',
    canActivate: [NotInDemoGuard],
    loadChildren: () => import('@features/market-place/market-place.module').then(m => m.MarketPlaceModule)
  },
  {
    path: 'filing-manager',
    loadChildren: () => import('@features/filing-manager/filing-manager.module').then(m => m.FilingManagerModule)
  },
  {
    // ITP-E-127-07: the platform calendar opens in its own tab and shell, so it loads on demand.
    path: 'calendar',
    loadChildren: () => import('@features/calendar/platform-calendar.module').then(m => m.PlatformCalendarModule)
  },
  {
    path: 'playground',
    loadChildren: () => import('@features/playground/playground.module').then(m => m.PlaygroundModule)
  },
  {
    // ITP-P-54 D19: XatBot Show is hidden inside a sales demo; a Show instance keeps it.
    path: 'xatbot-show',
    canActivate: [NotInSalesDemoGuard],
    loadChildren: () => import('@features/xatbot-show/xatbot-show.module').then(m => m.XatBotShowModule)
  },
  {
    path: 'dashboards',
    loadChildren: () => import('@features/intellicanvas/intellicanvas.module').then(m => m.IntelliCanvasModule)
  },
  {
    path: '',
    loadChildren: () => import('@features/account-settings/account-settings.module').then(m => m.AccountSettingsModule)
  },
  {
    path: '',
    loadChildren: () => import('@features/meet-dashboard/meet-dashboard.module').then(m => m.MeetDashboardModule)
  },

  // Orbitax Meet as a Solution on the ITP origin (MEET-E-02-04): the App Switcher opens `/meet` in a new window
  // and meeting links are `<ITP origin>/meet/<code>` (OrbitaxMeetBaseUrl). Its top bar has no rail, no XatBot and a
  // read-only project on every server (MEET-E-31-03).
  {
    path: 'meet',
    data: {topBar: MEET_SHELL_TOP_BAR},
    loadChildren: () => import('@features/orbitax-meet/orbitax-meet-shell.module').then(m => m.OrbitaxMeetShellModule)
  },
  // The viewer of a Meet broadcast (MEET-E-02-03): a signed-in user watches `/meet-broadcast/<meetId>` as HLS.
  // A dev/validation page, replaced by SHOW-P-01 E5's podcast audience page.
  {
    path: 'meet-broadcast',
    loadChildren: () => import('@features/meet-broadcast/meet-broadcast.module').then(m => m.MeetBroadcastModule)
  },
  {
    path: 'hr',
    loadChildren: homeModuleResolver
  },
  {
    path: '',
    loadChildren: () => import('@features/security/security.module').then(m => m.SecurityModule)
  },
  {
    path: 'generate-token',
    component:  GenerateTokenComponent,
    canActivate: [DevEnvGuard],
  },
  {
    path: 'my-devices',
    component: MyDevicesComponent,
    canActivate: [AuthGuard],
  },
  {
    path: '**',
    redirectTo: '/',
  },
];
function homeModuleResolver() {
  switch (Configuration.ApplicationId) {
    case 'Support':
      return SupportModule;
    case 'AdminPanel':
      return AdminPanelModule;
    default:
      return DashboardModule;
  }
}
